// Texto padrão do bloco "INFORMAÇÕES IMPORTANTES" do PDF do ingresso, usado
// quando o evento não tem `ticket_info` customizado (campo null/vazio).
// Formato: HTML gerado pelo RichTextEditor do painel (Tiptap) — ver
// buildTicketInfoRows abaixo pra conversão desse HTML em nós pdfmake.
export const DEFAULT_TICKET_INFO = `<p>1. Esse documento já é seu Ingresso Digital.</p><p>2. No dia do evento, basta apresentar o QR Code na portaria (impresso ou no celular).</p><p></p><p><strong>*** Comprei para mais pessoas. Preciso chegar junto?</strong></p><p>Não precisa. Cada ingresso é único e possui seu prório QR Code, podendo ser validado sozinho.</p><p></p><p><strong>*** Posso imprimir os ingressos?</strong></p><p>Não é necessário, mas se preferir pode imprimir seus ingressos em uma impressora comum (Papel A4 com fundo branco).</p>`

type TextRun = {
  text: string
  bold?: boolean
  italics?: boolean
  decoration?: string
  color?: string
  fontSize?: number
  link?: string
}

const styleFromElement = (el: HTMLElement, inherited: Partial<TextRun>): Partial<TextRun> => {
  const style: Partial<TextRun> = { ...inherited }
  const tag = el.tagName ? el.tagName.toLowerCase() : null

  if (tag === "strong" || tag === "b") style.bold = true
  if (tag === "em" || tag === "i") style.italics = true
  if (tag === "u") style.decoration = "underline"
  if (tag === "s" || tag === "strike" || tag === "del") style.decoration = "lineThrough"

  if (el.style?.color) style.color = el.style.color
  if (el.style?.fontSize) {
    const size = parseFloat(el.style.fontSize)
    if (!Number.isNaN(size)) style.fontSize = size
  }

  if (tag === "a") {
    const href = el.getAttribute?.("href")
    if (href) {
      style.link = href
      style.color = style.color || "#4C7CD0"
      style.decoration = "underline"
    }
  }

  return style
}

const walkInline = (node: ChildNode, inherited: Partial<TextRun>, runs: TextRun[]) => {
  if (node.nodeType === Node.TEXT_NODE) {
    if (node.textContent) runs.push({ text: node.textContent, ...inherited })
    return
  }
  if (node.nodeType !== Node.ELEMENT_NODE) return
  const el = node as HTMLElement
  if (el.tagName === "BR") {
    runs.push({ text: "\n" })
    return
  }
  const style = styleFromElement(el, inherited)
  el.childNodes.forEach((child) => walkInline(child, style, runs))
}

const inlineRuns = (el: HTMLElement): TextRun[] => {
  const runs: TextRun[] = []
  el.childNodes.forEach((child) => walkInline(child, {}, runs))
  if (runs.length === 0) runs.push({ text: "" })
  return runs
}

const HEADING_SIZE: Record<string, number> = { h1: 16, h2: 14, h3: 13 }

const blockToRows = (el: HTMLElement, rows: any[]) => {
  const tag = el.tagName.toLowerCase()

  if (tag === "blockquote") {
    el.childNodes.forEach((child) => {
      if (child.nodeType === Node.ELEMENT_NODE) blockToRows(child as HTMLElement, rows)
    })
    return
  }

  if (tag === "ul" || tag === "ol") {
    Array.from(el.children).forEach((li, idx) => {
      const prefix = tag === "ul" ? "•  " : `${idx + 1}.  `
      const runs = inlineRuns(li as HTMLElement)
      runs[0] = { ...runs[0], text: prefix + (runs[0]?.text || "") }
      rows.push([{ text: runs, style: "infoAnswer" }])
    })
    return
  }

  if (HEADING_SIZE[tag]) {
    const runs = inlineRuns(el).map((r) => ({
      ...r,
      bold: true,
      fontSize: r.fontSize || HEADING_SIZE[tag],
    }))
    rows.push([{ text: runs, style: "infoAnswer" }])
    return
  }

  // <p> e qualquer outro bloco não reconhecido: uma linha
  rows.push([{ text: inlineRuns(el), style: "infoAnswer" }])
}

export const buildTicketInfoRows = (ticketInfo?: string) => {
  const html = (ticketInfo && ticketInfo.trim()) || DEFAULT_TICKET_INFO
  const doc = new DOMParser().parseFromString(html, "text/html")

  const rows: any[] = []
  doc.body.childNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) blockToRows(node as HTMLElement, rows)
  })

  if (rows.length === 0) rows.push([{ text: "", style: "infoAnswer" }])

  return rows
}
